import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import DButton from "discourse/ui-kit/d-button";
import { isModMarketDiscussionFrame } from "../initializers/discourse-mod-market-embed-composer";

export default class ModMarketComposerCollapse extends Component {
  @service appEvents;

  get show() {
    return isModMarketDiscussionFrame({});
  }

  @action
  collapse() {
    this.appEvents.trigger("embed-composer:collapse");
  }

  <template>
    {{#if this.show}}
      <div class="mod-market-composer-actions">
        <DButton
          @action={{this.collapse}}
          @icon="xmark"
          @title="discourse_mod_market.detail.collapse_comment"
          class="btn-transparent mod-market-composer-actions__close"
        />
      </div>
    {{/if}}
  </template>
}
